import React from "react";
import { Row, Col, Modal, Button, Slider, Slide } from "react-materialize";

class NewsItem extends React.Component {
  render() {
    return (
        <Col className="pad-s" m={4} s={12}>
          <div className="fill">
            <img src={this.props.data.src} alt="blog_picture" />
          </div>

          <p>{this.props.data.author}</p>
          <h5>
            <a href={this.props.data.url} target="_blank">
              {this.props.data.title}
            </a>
          </h5>
        </Col>
    );
  }
}

export default NewsItem;



// WEBPACK FOOTER //
// ./src/components/Public/Home/NewsItem.js